import { render } from "./WbCards.vue?vue&type=template&id=1edec752"
import script from "./WbCards.vue?vue&type=script&lang=js"
export * from "./WbCards.vue?vue&type=script&lang=js"

import "./WbCards.vue?vue&type=style&index=0&id=1edec752&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__